"use client";

import { GlobalScrollProvider } from "@/providers/GlobalScroll/GlobalScrollProvider";
import { useTheme } from "@/providers/Theme/ThemeProvider";
import { UIKit } from "@itzme1on/uikit";

export default function UIKitWrapper({
	children,
}: {
	children: React.ReactNode;
}) {
	const { theme } = useTheme();

	return (
		<GlobalScrollProvider>
			<UIKit theme={theme}>{children}</UIKit>
		</GlobalScrollProvider>
	);
}
